import { useState, useEffect, memo } from "react";
import style from "./../index.module.scss";
import styleUi from "./Statistics.module.scss";
import * as YStyled from "../../Styleds";
import { CSSTransition } from 'react-transition-group';
import RadarChart from "../../comm/global/components/RadarChart";
import BarChart from "../../comm/global/components/BarChart";
import apiManager from '../../ApiManager';
const Statistics = ({ setModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [statistics, set_statistics] = useState(null);
    const [yearTimesData, set_yearTimesData] = useState([0, 4, 0, 0, 0, 0]);
    useEffect(() => {
        setInProp(true);
        document.title = "統計";
        apiManager.fetchGet(`users/statistics`, {}, 0).then(res => {
            console.log("res", res)
            set_statistics(res);
        })
    }, []);
    return (
        <div className={style.modal}>
            <CSSTransition
                in={inProp}
                timeout={{ appear: 0, enter: 300, exit: 0 }}
                classNames={{
                    enterActive: style.SwipePageEnterActive,
                    enterDone: style.SwipePageEnterDone,
                    exitActive: style.SwipePageExit,
                    exitDone: style.SwipePageExitActive
                }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "Statistics"));
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`}>
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={() => setInProp(false)} />
                            <YStyled.Span size={17} fontWeight={700}>統計</YStyled.Span>
                            <img src="./assets/ui/back.png" />
                        </div>
                        {statistics &&
                        <div className={styleUi.view}>
                            <YStyled.Row align="flex-start" gap=".4rem" style={{ margin: "1rem 0 2rem 0" }}>
                                <img src="./assets/ui/tip.svg" />
                                <YStyled.Span size={13} color="#828282" fontWeight={400}>距離你上次呼吸到自然新鮮的空氣，已經過了 2 個月</YStyled.Span>
                            </YStyled.Row>
                            <div className={styleUi.chartPanel}>
                                <YStyled.Span size={16} color="#828282" style={{ padding: ".4rem 0 .4rem 1.5rem", alignSelf: "flex-start" }}>每月野放次數統計</YStyled.Span>
                                <YStyled.Hr color="#ECECEC" style={{ margin: ".8rem 0", height: "2px" }} />
                                <div className={styleUi.chartBox}> 
                                    <BarChart labels={statistics.oosa_star_per_user.map(v=>`${v.user_period.month}月`)} 
                                    myData={statistics.oosa_star_per_user.map(v=>v.user_count)} 
                                    avgData={statistics.oosa_star_per_user.map(v=>v.average_star)} 
                                    total={statistics.oosa_star_per_user.map(v=>v.total_star)} 
                                     />
                                </div>
                            </div>
                            <div className={styleUi.chartPanel} style={{ marginTop: "1rem" }}>
                                <YStyled.Col style={{ paddingLeft: "1.5rem" }}>
                                    <YStyled.Span size={15} color="#828282" style={{}}>野放頻率</YStyled.Span>
                                    <YStyled.Row align="flex-start" style={{ alignItems: "flex-end", marginTop: "1rem" }} >
                                        <YStyled.Span size={40} color="#0B1354" fontFamily="SF Pro" style={{ lineHeight: "1.6rem" }}>{statistics?.user_star_per_year}</YStyled.Span>
                                        <YStyled.Span size={13} fontWeight={400} color="#4F4F4F" fontFamily="SF Pro" style={{}}>次/年</YStyled.Span>
                                    </YStyled.Row>
                                </YStyled.Col>
                                <YStyled.Hr color="#ECECEC" style={{ margin: "1.8rem 0 0 0", height: "2px" }} />
                                <div className={styleUi.chartBox} style={{ height: "20rem" }}>
                                    {statistics?.user_star_by_type &&
                                        <RadarChart label={statistics.user_star_by_type.map(v=>v.event_type_name)} data={statistics.user_star_by_type.map(v=>v.event_count)} />
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
};

export default memo(Statistics);
